import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/wegweiser/$routeSignLocationId')({
  beforeLoad: ({ params }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: `/beschilderung/$routeSignLocationId`,
      params,
      search: {
        details: true,
        qr: true,
      },
    });
  },
});
